var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.14234 30.0642H8.59692V16.8175L5.02518 10.5806L0.804688 10.9733V27.7266C0.804688 29.0181 1.8508 30.0642 3.14234 30.0642Z",
    fill: "#0085F7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2979 30.0642H32.7524C34.044 30.0642 35.0901 29.0181 35.0901 27.7266V10.9733L30.8757 10.5806L27.2979 16.8175V30.0642H27.2979Z",
    fill: "#00A94B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2983 6.68757L24.0942 12.8016L27.2983 16.8175L35.0905 10.9733V7.85643C35.0905 4.96746 31.7925 3.31746 29.4801 5.05123L27.2983 6.68757Z",
    fill: "#FFBC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59705 16.8174L5.54395 10.3681L8.59705 6.6875L17.9477 13.7005L27.2983 6.6875V16.8174L17.9477 23.8304L8.59705 16.8174Z",
    fill: "#FF4131"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.804688 7.85643V10.9733L8.59692 16.8175V6.68757L6.41509 5.05123C4.10275 3.31746 0.804688 4.96746 0.804688 7.85643Z",
    fill: "#E51C19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmail);
export default __webpack_public_path__ + "static/media/gmail.87388caade89f9e243b64b0a8ab81d23.svg";
export { ForwardRef as ReactComponent };